import React from 'react'

interface ISelectSharingGroupIconProps {
  className?: string
}

export const SelectSharingGroupIcon = ({ className }: ISelectSharingGroupIconProps) => {
  return (
    <svg className={className} viewBox="0 0 545 299" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Add a group</title>
      <defs>
        <rect id="path-1" x="0" y="50" width="539" height="245"></rect>
        <filter x="-0.9%" y="-1.6%" width="101.9%" height="104.1%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
          <feColorMatrix
            values="0 0 0 0 0.8   0 0 0 0 0.8   0 0 0 0 0.8  0 0 0 1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <filter x="-66.7%" y="-44.4%" width="233.3%" height="188.9%" filterUnits="objectBoundingBox" id="filter-3">
          <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <polygon id="path-4" points="0.868 0.3076 0.868 1.1076 0.78672 1.1076 0.78672 0.3076 0.868 0.3076"></polygon>
        <polygon id="path-6" points="1.07256 0.8 0.27256 0.8 0.27256 0.27096 1.07256 0.27096"></polygon>
        <polygon id="path-8" points="0.868 0.09432 0.868 0.89432 0.1348 0.89432 0.1348 0.09432 0.868 0.09432"></polygon>
        <polygon id="path-10" points="0.868 0.44856 0.868 0.8 0.13464 0.8 0.13464 0.44856 0.868 0.44856"></polygon>
        <polygon
          id="path-12"
          points="5.6338 16.8 0 16.8 0 0.4016 5.6338 0.4016 11.2676 0.4016 11.2676 16.8 5.6338 16.8"
        ></polygon>
      </defs>
      <g id="1-Onboarding" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="SVG-images" transform="translate(-96.000000, -1537.000000)">
          <g id="Add-a-group" transform="translate(99.000000, 1537.000000)">
            <rect id="Rectangle" stroke="#2196F3" fill="#FFFFFF" x="0.5" y="0.5" width="539" height="49" rx="2"></rect>
            <g id="Rectangle">
              <use fill="black" fillOpacity="1" filter="url(#filter-2)" href="#path-1"></use>
              <rect
                stroke="#E5E5E5"
                strokeWidth="1"
                strokeLinejoin="miter"
                fill="#FFFFFF"
                fillRule="evenodd"
                x="0.5"
                y="50.5"
                width="538"
                height="244"
              ></rect>
            </g>
            <rect id="Rectangle" fill="#FFFFFF" x="1" y="94" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="13" y="117">
                
              </tspan>
            </text>
            <text
              id="Finance-&amp;-Billing-(7"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="45" y="116">
                SpaceX Engineering (28)
              </tspan>
            </text>
            <text
              id="Edit-group"
              opacity="0.501122611"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#95B1C9"
            >
              <tspan x="473" y="114">
                Edit group
              </tspan>
            </text>
            <rect id="Rectangle" fill="#F2F2F2" x="0" y="126" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="12" y="149">
                
              </tspan>
            </text>
            <text
              id="Dream-Team-(5)"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="44" y="148">
                Team Get 'R Done (5)
              </tspan>
            </text>
            <text id="Edit-group" fontFamily="Roboto-Regular, Roboto" fontSize="12" fontWeight="normal" fill="#95B1C9">
              <tspan x="472" y="146">
                Edit group
              </tspan>
            </text>
            <g id="Group" transform="translate(207.000000, 134.000000)">
              <g id="CURSOR-TYPE" filter="url(#filter-3)" transform="translate(3.000000, 0.000000)">
                <path
                  d="M8.02128,9.67048 C8.02208,9.66888 8.02368,9.66648 8.02448,9.66488 L8.04208,9.73048 L8.02128,9.67048 Z M9.21728,14.04808 C9.21728,13.96488 9.24368,13.88408 9.29088,13.81608 L9.96928,12.86088 C10.25248,12.46168 10.40288,11.99048 10.40288,11.49848 L10.40288,7.59768 C10.40288,5.93768 10.22608,5.66408 9.62208,5.61288 L9.62208,6.79768 C9.62208,7.01928 9.44368,7.19768 9.22208,7.19768 C9.00128,7.19768 8.82208,7.01928 8.82208,6.79768 L8.82208,5.25768 C8.77568,5.11688 8.59168,4.73528 7.97568,4.74328 L7.97568,6.79768 C7.97568,7.01928 7.79648,7.19768 7.57568,7.19768 C7.35408,7.19768 7.17568,7.01928 7.17568,6.79768 L7.17568,4.47528 C7.10048,4.34248 6.87888,4.03368 6.46768,3.99768 L6.46768,6.79768 C6.46768,7.01928 6.28848,7.19768 6.06768,7.19768 C5.84608,7.19768 5.66768,7.01928 5.66768,6.79768 L5.66768,4.05848 C5.66688,4.04888 5.66208,4.04088 5.66208,4.03128 L5.66208,2.39768 C5.66208,1.95128 5.35248,1.60888 4.94208,1.60008 C4.50448,1.60968 4.09088,1.98968 4.09088,2.39768 L4.09088,8.12328 C4.09088,8.29288 3.98448,8.44328 3.82528,8.50008 C3.66848,8.55768 3.48848,8.50728 3.38128,8.37768 L2.15968,6.88808 C2.01888,6.74728 1.80768,6.65528 1.59008,6.65528 L1.58928,6.65528 C1.37168,6.65528 1.16048,6.74728 0.99408,6.91528 C0.73168,7.18168 0.74128,7.62808 1.01488,7.91048 L2.11888,9.49128 C2.61408,10.20248 3.01248,10.97928 3.30208,11.79848 C3.56528,12.60168 4.18128,13.77688 4.67648,13.77688 C4.89648,13.77688 5.07568,13.95528 5.07648,14.17608 L5.07728,14.79768 L9.21728,14.79768 L9.21728,14.26488 L9.21728,14.04808 Z"
                  id="Fill-1"
                  fill="#FFFFFF"
                ></path>
                <g id="Group-5" transform="translate(10.400000, 6.798080)">
                  <mask id="mask-5" fill="white">
                    <use href="#path-4"></use>
                  </mask>
                  <g id="Clip-4"></g>
                  <path
                    d="M0.78672,0.3076 C0.79072,0.398 0.79392,0.4892 0.79552,0.5868 C0.79392,0.4908 0.79152,0.3956 0.78672,0.3076"
                    id="Fill-3"
                    fill="#FFFFFF"
                    mask="url(#mask-5)"
                  ></path>
                </g>
                <g id="Group-8" transform="translate(3.200000, 16.398080)">
                  <mask id="mask-7" fill="white">
                    <use href="#path-6"></use>
                  </mask>
                  <g id="Clip-7"></g>
                  <path
                    d="M0.27256,0.27096 C0.40216,0.46216 0.58536,0.61496 0.80056,0.70536 C0.58536,0.61496 0.40216,0.46216 0.27256,0.27096"
                    id="Fill-6"
                    fill="#FFFFFF"
                    mask="url(#mask-7)"
                  ></path>
                </g>
                <g id="Group-11" transform="translate(10.400000, 14.798080)">
                  <mask id="mask-9" fill="white">
                    <use href="#path-8"></use>
                  </mask>
                  <g id="Clip-10"></g>
                  <path
                    d="M0.1348,0.09432 C0.278,0.15512 0.4076,0.24312 0.5164,0.35112 C0.4076,0.24312 0.278,0.15512 0.1348,0.09432"
                    id="Fill-9"
                    fill="#FFFFFF"
                    mask="url(#mask-9)"
                  ></path>
                </g>
                <path
                  d="M4.00064,14.8924 C3.78544,14.9836 3.60224,15.1356 3.47264,15.3268 C3.60224,15.1356 3.78544,14.9836 4.00064,14.8924"
                  id="Fill-12"
                  fill="#FFFFFF"
                ></path>
                <path
                  d="M10.0676,15.59808 L9.6004,15.59808 L4.6788,15.59808 L4.4676,15.59808 C4.2468,15.59808 4.0676,15.77728 4.0676,15.99808 C4.0676,16.21888 4.2468,16.39808 4.4676,16.39808 L10.0676,16.39808 C10.2884,16.39808 10.4676,16.21888 10.4676,15.99808 C10.4676,15.77728 10.2884,15.59808 10.0676,15.59808"
                  id="Fill-14"
                  fill="#FFFFFF"
                ></path>
                <g id="Group-18" transform="translate(10.400000, 16.398080)">
                  <mask id="mask-11" fill="white">
                    <use href="#path-10"></use>
                  </mask>
                  <g id="Clip-17"></g>
                  <path
                    d="M0.51624,0.44856 C0.40744,0.55736 0.27864,0.64536 0.13464,0.70536 C0.27864,0.64536 0.40744,0.55736 0.51624,0.44856"
                    id="Fill-16"
                    fill="#FFFFFF"
                    mask="url(#mask-11)"
                  ></path>
                </g>
                <g transform="translate(0.000000, 0.398080)">
                  <mask id="mask-13" fill="white">
                    <use href="#path-12"></use>
                  </mask>
                  <g id="Clip-20"></g>
                  <path
                    d="M10.0676,16 L4.4676,16 C4.2468,16 4.0676,15.8208 4.0676,15.6 C4.0676,15.3792 4.2468,15.2 4.4676,15.2 L4.6788,15.2 L9.6004,15.2 L10.0676,15.2 C10.2884,15.2 10.4676,15.3792 10.4676,15.6 C10.4676,15.8208 10.2884,16 10.0676,16 L10.0676,16 Z M5.078,14.4 L5.0764,13.7776 C5.0756,13.5568 4.8964,13.3784 4.6764,13.3784 C4.182,13.3784 3.5652,12.2032 3.302,11.4008 C3.0124,10.5808 2.6148,9.804 2.1188,9.0936 L1.0156,7.5128 C0.7412,7.2304 0.7316,6.7832 0.994,6.5176 C1.1604,6.3496 1.3716,6.2568 1.5892,6.2568 L1.59,6.2568 C1.8076,6.2568 2.0188,6.3496 2.1596,6.4904 L3.382,7.9792 C3.4884,8.1096 3.6684,8.16 3.8252,8.1016 C3.9844,8.0448 4.0908,7.8944 4.0908,7.7256 L4.0908,2 C4.0908,1.5912 4.5044,1.2112 4.942,1.2016 C5.3524,1.2104 5.662,1.5536 5.662,2 L5.662,3.6336 C5.662,3.6432 5.6668,3.6512 5.6676,3.66 L5.6676,6.4 C5.6676,6.6208 5.8468,6.8 6.0676,6.8 C6.2884,6.8 6.4676,6.6208 6.4676,6.4 L6.4676,3.5992 C6.8788,3.636 7.1004,3.944 7.1756,4.0776 L7.1756,6.4 C7.1756,6.6208 7.354,6.8 7.5756,6.8 C7.7964,6.8 7.9756,6.6208 7.9756,6.4 L7.9756,4.3448 C8.5916,4.3376 8.7756,4.7192 8.822,4.8592 L8.822,6.4 C8.822,6.6208 9.0012,6.8 9.222,6.8 C9.4436,6.8 9.622,6.6208 9.622,6.4 L9.622,5.2152 C10.226,5.2664 10.4028,5.54 10.4028,7.2 L10.4028,11.1 C10.4028,11.5928 10.2524,12.064 9.9692,12.4632 L9.2908,13.4184 C9.2436,13.4864 9.218,13.5672 9.218,13.6496 L9.218,13.8664 L9.218,14.4 L5.078,14.4 Z M10.9164,14.7512 C10.8076,14.6432 10.678,14.5552 10.5348,14.4944 C10.3916,14.4336 10.2332,14.4 10.0676,14.4 L10.018,14.4 L10.018,13.8664 L10.018,13.7776 L10.622,12.9264 C11.002,12.3904 11.2028,11.7592 11.2028,11.1 L11.2028,7.2 C11.2028,7.1208 11.1972,7.0616 11.1956,6.9872 C11.194,6.8896 11.1908,6.7984 11.1868,6.7072 C11.1076,4.8352 10.5676,4.4632 9.4996,4.4088 C9.2748,3.9664 8.7484,3.468 7.7884,3.552 C7.602,3.28 7.2252,2.9136 6.63,2.8264 C6.5804,2.804 6.526,2.7904 6.4676,2.7904 L6.462,2.7904 L6.462,2 C6.462,1.1208 5.802,0.4192 4.942,0.4016 C4.0476,0.42 3.2908,1.152 3.2908,2 L3.2908,6.6088 L2.7532,5.9552 C2.4372,5.6336 2.0236,5.4568 1.59,5.4568 L1.5892,5.4568 C1.1564,5.4568 0.7428,5.6336 0.4252,5.9552 C-0.1412,6.5288 -0.134,7.4768 0.3996,8.0192 L1.4628,9.5496 C1.9172,10.2024 2.282,10.9152 2.5444,11.6584 C2.6668,12.032 3.2716,13.7296 4.2772,14.1048 L4.278,14.4192 C4.1812,14.4344 4.0876,14.4576 4.0004,14.4944 C3.7852,14.5856 3.602,14.7376 3.4724,14.9288 C3.3428,15.1208 3.2676,15.3512 3.2676,15.6 C3.2676,15.8488 3.3428,16.0792 3.4724,16.2712 C3.602,16.4624 3.7852,16.6144 4.0004,16.7056 C4.1444,16.7664 4.302,16.8 4.4676,16.8 L10.0676,16.8 C10.2332,16.8 10.3916,16.7664 10.5348,16.7056 C10.678,16.6448 10.8076,16.5568 10.9164,16.4488 C11.1332,16.2312 11.2676,15.9312 11.2676,15.6 C11.2676,15.2688 11.1332,14.9688 10.9164,14.7512 L10.9164,14.7512 Z"
                    id="Fill-19"
                    fill="#000000"
                    mask="url(#mask-13)"
                  ></path>
                </g>
              </g>
            </g>
            <rect id="Rectangle" fill="#FFFFFF" x="0" y="158" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="12" y="181">
                
              </tspan>
            </text>
            <text
              id="Finance-&amp;-Billing-(7"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="44" y="180">
                Finance &amp; Billing (7)
              </tspan>
            </text>
            <text
              id="Edit-group"
              opacity="0.501122611"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#95B1C9"
            >
              <tspan x="472" y="178">
                Edit group
              </tspan>
            </text>
            <rect id="Rectangle" fill="#FFFFFF" x="0" y="190" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="12" y="213">
                
              </tspan>
            </text>
            <text
              id="Finance-&amp;-Billing-(7"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="44" y="212">
                Leadership (4)
              </tspan>
            </text>
            <text
              id="Edit-group"
              opacity="0.501122611"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#95B1C9"
            >
              <tspan x="472" y="210">
                Edit group
              </tspan>
            </text>
            <rect id="Rectangle" fill="#FFFFFF" x="0" y="222" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="12" y="245">
                
              </tspan>
            </text>
            <text
              id="Finance-&amp;-Billing-(7"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="44" y="244">
                Procurment Team (2)
              </tspan>
            </text>
            <text
              id="Edit-group"
              opacity="0.501122611"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#95B1C9"
            >
              <tspan x="472" y="242">
                Edit group
              </tspan>
            </text>
            <rect id="Rectangle" fill="#FFFFFF" x="0" y="254" width="537" height="32"></rect>
            <text id="people---material" fontFamily="material" fontSize="20" fontWeight="normal" fill="#6B6B6B">
              <tspan x="12" y="277">
                
              </tspan>
            </text>
            <text
              id="Finance-&amp;-Billing-(7"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="16"
              fontWeight="normal"
              fill="#6B6B6B"
            >
              <tspan x="44" y="276">
                Recruiters 2nd step (4)
              </tspan>
            </text>
            <text
              id="Edit-group"
              opacity="0.501122611"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#95B1C9"
            >
              <tspan x="472" y="274">
                Edit group
              </tspan>
            </text>
            <rect id="Rectangle" fill="#FFFFFF" x="1" y="50" width="537" height="44"></rect>
            <text id="+-New-group" fontFamily="Roboto-Regular, Roboto" fontSize="16" fontWeight="normal" fill="#2196F3">
              <tspan x="13" y="78">
                + New group
              </tspan>
            </text>
            <text
              fontFamily="Roboto-LightItalic, Roboto"
              fontSize="20"
              fontStyle="italic"
              fontWeight="300"
              fill="#3A3F42"
            >
              <tspan x="18" y="33">
                Add a group
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  )
}
